import { render, staticRenderFns } from "./popup-remark-detail.vue?vue&type=template&id=d1389802&scoped=true"
import script from "./popup-remark-detail.vue?vue&type=script&lang=js"
export * from "./popup-remark-detail.vue?vue&type=script&lang=js"
import style0 from "./popup-remark-detail.vue?vue&type=style&index=0&id=d1389802&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1389802",
  null
  
)

export default component.exports